
import React, { useEffect, useState, useRef } from "react";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import "./DashboardVariableFormModal.css"
import CheckBox from "/src/components/UI/CheckBox/CheckBox"
import { DashboardVariableTypeDropdown } from "../../../variableType"
import Dropdown from "/src/components/UI/DropDown/DropDown"
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import Tooltip from "../../Tooltip/Tooltip";
import useDropdownDashboard from "../../../hooks/useDropdownDashboard"
import { checkNumber } from "../../../checkNumber";

const DashboardVariableFormMain = ({ setValue, watch, register, variable, variablesBot, getValues }) => {

    const isButton = () => variable?.type == 3;

    const isNumber = () => variable?.type == 4;


    const { dropdownDefaultValue, modifyDropdownValues } = useDropdownDashboard(getValues("value_dropdown"));

    return (
        <>
            <div className="dropdown_container dropdown_dashboard_variable_container">
                <Field label="Type variable" listLabelClassName="field-modal"></Field>
                <div style={{ position: "relative" }}>
                    <Dropdown {...register('type', { valueAsNumber: true })} setValue={setValue} choices={DashboardVariableTypeDropdown} width="240px" defaultChoice={variable ? variable.type : 0}></Dropdown>
                </div>
            </div>
            {
                watch("type") != 3 &&

                <div className="dropdown_container">
                    <Field label="Variable from the bot" listLabelClassName="field-modal"></Field>
                    <div style={{ marginTop: "2%" }}>
                        {
                            variablesBot != "" &&
                            <Dropdown {...register('bot_variable_id', { valueAsNumber: true })} setValue={setValue} choices={variablesBot} width="240px" defaultChoice={variable?.bot_variable_id}></Dropdown>

                        }
                    </div>

                </div>
            }

            {
                watch('type') == 2 &&
                <div className="type_dropdown_container">
                    <div style={{ display: 'flex' }}>
                        <Field label="Variables in the dropdown" listLabelClassName="field-modal" />
                        <Tooltip classNameContainer={"top"} classNameBoxText="tooltip_upper" text={"You have to put value like : Orange|Banana|Tomato separate with pipes |"}></Tooltip>
                    </div>
                    <TextInput {...register('value_dropdown')} onChange={(e) => modifyDropdownValues(e.target.value)} onKeyUp={(e) => modifyDropdownValues(e.target.value)} placeholder="Example : Orange|Banana|Tomato" className={"input_variable_dashboard_form"}></TextInput>
                </div>
            }
            <div className={"title_container " + (watch("type") == 3 ? "form_container_title" : "")}>
                <Field label={"Renamed variable in the dashboard"} listLabelClassName="field-modal" />
                <TextInput {...register('label', { required: true, minLength: 3 })} placeholder={watch("type") == 3 ? "Enter the label of the button action" : "Enter your variable's title"} className={"input_variable_dashboard_form"}></TextInput>
            </div>

            {
                watch('type') == 0 &&
                <div className="checkbox_dashboard_variable_container">
                    <Field label="Default value" listLabelClassName={"field-modal"} />
                    <div style={{ marginRight: "100px" }}>
                        <CheckBox  {...register('empty')} name={"default_value_checkbox"} onChange={() => setValue("default_value_checkbox", !getValues("default_value_checkbox"))} checked={getValues("default_value_checkbox")}></CheckBox>
                    </div>
                </div>
            }
            {
                watch("type") == 1 &&
                <div className={"title_container"}>
                    <Field label="Default value" listLabelClassName={"field-modal"} />
                    <TextInput {...register('default_value', { maxLength: 200 })} placeholder="Enter the default value" className={"input_variable_dashboard_form"} ></TextInput>
                </div>
            }
            {
                watch('type') == 2 && dropdownDefaultValue.length > 0 &&
                <div className={"dropdown_container"}>
                    <Field label="Default value" listLabelClassName={"field-modal"} />
                    <div style={{ marginTop: "2%" }}>
                        <Dropdown key={Date.now()} {...register('default_value_dropdown', { valueAsNumber: true })} choices={dropdownDefaultValue} defaultChoice={variable?.default_value} width="240px" heightFix="55px" setValue={setValue} ></Dropdown>
                    </div>
                </div>
            }

            {
                watch('type') == 3 &&
                <>
                    <div className="title_container form_container_title">
                        <Field label={"Text on the button"} listLabelClassName="field-modal" />
                        <TextInput {...register('default_value', { required: true, minLength: 3 })} placeholder={watch("type") == 3 ? "Enter the label of the button action" : "Enter your variable's title"} className={"input_variable_dashboard_form"}></TextInput>
                    </div>
                    <div className="title_container form_container_title">
                        <Field label="Tracking ID of the action" listLabelClassName={"field-modal"} />
                        <TextInput {...register('value', { required: true, minLength: 3, maxLength: 200 })} defaultValue={isButton() ? variable.value : ""} placeholder="Enter the tracking ID where the API action is" className={"input_variable_dashboard_form"} ></TextInput>
                    </div>
                </>
            }
            {
                watch('type') == 4 &&
                <div className="title_container">
                    <Field label="Default value" listLabelClassName={"field-modal"} />
                    <div>
                        <TextInput type="number"  {...register('default_value_number', { required: true, minLength: 1 })} defaultValue={isNumber() ? parseInt(variable.value) : ""} onKeyDown={(e) => checkNumber(e)} placeholder="Enter the default value number" className={"input_variable_dashboard_form"} />
                    </div>
                </div>
            }

            <div className="dashboard_advanced_parameters" onClick={() => ScrollIntoSlide(watch('type') == 3 ? "button_result" : "advanced")}> {watch('type') == 3 ? "Button" : "Advanced"} Parameters <i className="fas fa-arrow-right" style={{ marginLeft: "5px", marginTop: watch("type") == 2 ? "25px" : "" }}></i></div>
        </>
    )
}
export default DashboardVariableFormMain